import { render, staticRenderFns } from "./zqn.vue?vue&type=template&id=226ac02b&scoped=true"
import script from "./zqn.vue?vue&type=script&lang=js"
export * from "./zqn.vue?vue&type=script&lang=js"
import style0 from "./zqn.vue?vue&type=style&index=0&id=226ac02b&prod&lang=scss&scoped=true"
import style1 from "./zqn.vue?vue&type=style&index=1&id=226ac02b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ac02b",
  null
  
)

export default component.exports